import { render } from "./logout.vue?vue&type=template&id=6d655482&scoped=true"
const script = {}

import "./logout.vue?vue&type=style&index=0&id=6d655482&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d655482"]])

export default __exports__